<template>
  <div
    class="app flex-row align-items-center bg-img"
    :style="backgroundImage"
    style="background-size:cover"
  >
    <div class="container">
      <div
        v-if="positionScreen"
        class="row"
        :class="'justify-content-' + positionScreen"
      >
        <div class="col-md-5">
          <div class="card-group mb-0">
            <div
              class="card p-4"
              style="height: 500px; border-radius: 10px; position: relative;"
            >
              <div class="col login-block-logo text-center">
                <img :src="logoImage" style="max-width: 240px; max-height: 70px;" />
              </div>

              <!-- Agrupando corretamente os componentes -->
              <template v-if="showMfaScreen">
                <MfaScreen @LoginMFA="SignInMFA" />
              </template>

              <template v-else-if="passwordExpired">
                <ChangePassword
                  :username="credentials.username"
                  @login="singIn"
                  @BackToLogin="backToLogin"
                />
              </template>

              <template v-else-if="resetPass">
                <LostPassword
                  :expiredPassword="passwordExpired"
                  @BackToLogin="backToLogin"
                />
              </template>

              <template v-else-if="loginFila">
                <LoginFila @LoginFila="singInFila" />
              </template>

              <template v-else>
                <LoginScreen
                  @Login="singIn"
                  @ResetPassword="resetPassword"
                />
              </template>

              <div class="toggle-login-container" v-if="!resetPass && !passwordExpired">
                <label class="toggle-login-label">
                  <input
                    type="checkbox"
                    v-model="loginFila"
                    @change="toggleLogin"
                  />
                  <span class="toggle-login-text" style="color: #04A791;">
                    {{ loginFila ? 'Login NxCoop' : 'Login NxSenha' }}
                  </span>
                </label>
              </div>

              <div
                class="row justify-content-left pt-3"
                style="position:absolute; top:360px; left: 50px;"
              >
                <a
                  href="http://nexum.com.br"
                  target="_blank"
                  style="color: #04A791;"
                >
                  Plataforma nxCoop <br />
                  {{ $lang.Login.LabelVersion }} {{ version }} <br />
                  Uso autorizado para {{ nomeCliente }}
                </a>
              </div>

              <div class="col login-bottom-logo text-right">
                <img src="/static/img/logotipo/logo.svg" style="width: 150px" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { loading, toast } from '@/shared/utils/UIHelper'
import LoginScreen from '@/views/public/auth/login/login.vue'
import LoginFila from '@/views/public/auth/login/loginFila.vue'
import EnvironmentRepository from '@/shared/http/repositories/access/environment'
import MfaScreen from './mfa/mfa.vue'
import { mapActions } from 'vuex'
import { globalActions as authActions } from '@/store/module/auth/actionTypes'
import SignInMixin from '@/store/module/signIn/mixin.js'
import LostPassword from '@/views/public/auth/lost/LostPassword.vue'
import ChangePassword from '@/views/public/auth/change/ChangePassword.vue'

import ParametroViewbRepository from '@/shared/http/repositories/configurations/parametroViewb.js'
import AccountRepository from '@/shared/http/repositories/access/account'
import AccountMixin from '@/store/module/account/mixin'

export default {
  data () {
    return {
      nomeCliente: process.env.Nome_Cooperativa,
      version: process.env.VersionApp,
      backgroundImage: null,
      logoImage: null,
      positionScreen: null,
      login: true,
      loginFila: false,
      resetPass: false,
      passwordExpired: false,
      urlApiViewb: null,
      showMfaScreen: false
    }
  },
  components: {
    LoginScreen,
    MfaScreen,
    LostPassword,
    ChangePassword,
    LoginFila
  },
  mixins: [SignInMixin, AccountMixin],
  created () {
    this.getImageAndLogo()
    this.getViewbApiUrl()
  },
  computed: {
    toggleLoginText () {
      return this.loginFila ? 'Alterar para Login NxSenhas' : 'Alterar para Login NxCoop'
    }
  },
  methods: {
    ...mapActions({
      signIn: authActions.SIGN_IN,
      signInFila: authActions.SIGN_IN_FILA
    }),
    singIn (user, pass) {
      this.credentials.username = user
      this.credentials.password = pass
      this.credentials.authCode = undefined
      this.signInAndRedirect()
    },
    toggleLogin () {
      if (this.loginFila && this.$route.name !== 'SignInFila') {
        this.$router.push({ name: 'SignInFila' })
      } else if (!this.loginFila && this.$route.name !== 'SignIn') {
        this.$router.push({ name: 'SignIn' })
      }
    },
    singInFila (user, pass) {
      this.credentials.username = user
      this.credentials.password = pass
      this.credentials.authCode = undefined
      this.signInAndRedirectFila()
    },
    SignInMFA (mfa) {
      this.credentials.authCode = mfa
      this.showMfaScreen = false
      this.signInAndRedirect()
    },
    async signInAndRedirect () {
      try {
        const valid = await this.$validator.validateAll()
        if (!valid) throw new Error('Falha ao validar credenciais')

        const success = await this.signIn(this.credentials)
        if (!success) throw new Error('Falha ao realizar login no nxCoop')

        if (this.urlApiViewb) {
          await this.loginToViewb(this.credentials)
        } else {
          this.$router.push({ name: 'PaginaInicial' })
        }
      } catch (error) {
        console.log('2 error: ' + error)
        this.handleLoginError(error)
      }
    },

    async signInAndRedirectFila () {
      try {
        const valid = await this.$validator.validateAll()
        if (!valid) throw new Error('Falha ao validar credenciais')

        const success = await this.signInFila(this.credentials)
        if (!success) throw new Error('Falha ao realizar login no nxCoop')
        document.cookie = `username=${this.credentials.username}; path=/; max-age=${7 * 24 * 60 * 60}`
        this.$router.push({ name: 'StartPageFila' })

        // if (this.urlApiViewb) {
        //   await this.loginToViewb(this.credentials)
        // } else {
        //   this.$router.push({ name: 'PaginaInicial' })
        // }
      } catch (error) {
        console.log('2 error: ' + error)
        this.handleLoginError(error)
      }
    },
    async loginToViewb () {
      var conta = await AccountRepository.GetLogged()

      const viewbCredentials = `username=${encodeURIComponent(conta.data.pessoa.emailCorporativo)}&password=${encodeURIComponent(this.credentials.password)}&remember=false`

      try {
        const response = await fetch(`${this.urlApiViewb}/auth/login`, {
          headers: {
            'accept': 'application/json, text/plain, */*',
            'content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
          body: viewbCredentials,
          method: 'POST',
          mode: 'cors',
          credentials: 'include'
        })

        if (!response.ok) {
          throw new Error('Falha ao logar na viewb')
        }

        this.$router.push({ name: 'PaginaInicial' })
      } catch (err) {
        console.error('falha ao logar na viewb ', err)
        this.$router.push({ name: 'PaginaInicial' })
      }
    },
    handleLoginError (error) {
      console.error('Erro ao realizar login:', error)
      const headersRaw = error.data && error.data.headers ? error.data.headers : {}
      // Normaliza chaves para lowercase
      const headers = Object.fromEntries(
        Object.entries(headersRaw).map(([k, v]) => [k.toLowerCase(), v])
      )

      if (headers['x-auth-response'] === 'PASSWORD_EXPIRED') {
        toast.error(this.$lang.Login.PasswordExpired)
        this.setChangePassword()
      } else if (headers['x-auth-response'] === 'USER_BLOCKED') {
        toast.error(this.$lang.Login.BlockedAccount)
      } else if (headers['step'] && headers['step'].toLowerCase() === 'authcode') {
        this.showMfaScreen = true
        this.loginFila = false
      } else {
        toast.error(this.$lang.Login.InvalidCredentials)
      }
    },
    getImageAndLogo () {
      loading.push()
      EnvironmentRepository.getEnv()
        .then(response => {
          this.setBackgroudImage(response.data.hasBackground)
          this.setPosicaoModal(response.data.posicao)
          this.setLogo(response.data.hasLogo)
          loading.pop()
        })
        .catch(() => {
          this.setDefaultEnv()
          loading.pop()
        })
    },
    async getViewbApiUrl () {
      try {
        const response = await ParametroViewbRepository.GetParams()
        if (response.status === 200) {
          this.urlApiViewb = response.data.urlApiBase
            ? response.data.urlApiBase
            : null
        }
      } catch (error) {
        console.error(error)
        this.onException(error)
      }
    },
    setBackgroudImage (hasBackground) {
      if (!hasBackground) {
        this.backgroundImage =
          'background-image: url("/static/img/bg/bg-01.jpg")'
      } else {
        this.backgroundImage =
          'background-image: url("' +
          process.env.APIBaseURLCore +
          '/environment/background' +
          '")'
      }
    },
    setPosicaoModal (posicao) {
      if (posicao === 'DIREITA') {
        this.positionScreen = 'end'
      } else if (posicao === 'CENTRO') {
        this.positionScreen = 'center'
      } else {
        this.positionScreen = 'start'
      }
    },
    setLogo (hasLogo) {
      if (!hasLogo) {
        this.logoImage = '/static/img/logotipo/logo-branco.svg'
      } else {
        this.logoImage = process.env.APIBaseURLCore + '/environment/logo'
      }
    },
    setDefaultEnv () {
      this.backgroundImage =
        'background-image: url("/static/img/bg/bg-01.jpg")'
      this.logoImage = '/static/img/logotipo/logo-branco.svg'
      this.positionScreen = 'start'
      this.urlApiViewb = null
    },
    setChangePassword () {
      this.passwordExpired = true
      this.loginFila = false
    },
    resetPassword () {
      this.resetPass = true
      this.loginFila = false
    },
    backToLogin () {
      this.passwordExpired = false
      this.resetPass = false
      this.loginFila = false
    }
  }
}
</script>

<style scoped>
#LoginScreen,
#MfaScreen {
  position: relative;
  top: 300px;
}

.card {
  background: linear-gradient(
    to bottom,
    #04a791 0%,
    #04a791 20%,
    white 20%,
    white 72%,
    #f5f5f5 72%,
    #f5f5f5 100%
  );
}

.login-block-logo {
  position: absolute;
  top: 15px;
}

.login-bottom-logo {
  position: absolute;
  top: 450px;
  left: 10px;
}

.toggle-login-container {
  display: flex;
  align-items: center;
  position: absolute;
  width: 30%;
  top: 320px;
  z-index: 10;
  height: 50px;
}

.toggle-login-label {
  margin-left: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.toggle-login-label input[type="checkbox"] {
  position: relative;
  margin-left: 11px;
  top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/public/auth/Authentication.vue